import { Box } from '@mui/material';
import styles from './AddedEvents.module.scss';
import CustomTypography from '../../customTypography/CustomTypography';
import LogoPtakExpo from '../../../assets/LogoPtakExpo.png';
import StarOutlineIcon from '@mui/icons-material/StarOutline';
import { ReactComponent as Wastebasket } from '../../../assets/wastebasket.svg';
import { ReactComponent as EditIcon} from '../../../assets/edit.svg';
import { ReactComponent as EditBlueIcon} from '../../../assets/editBlue.svg';
import { useState, useCallback } from 'react';
import { _AddedEvent } from '../../../types/types';
import { useAuth } from '../../../contexts/AuthContext';
import { deleteTradeEvent } from '../../../services/api';
import EventTypeBadge from '../../eventTypeBadge/EventTypeBadge';
import { textColorPicker } from '../../../helpers/function';



interface AddedEventsProps {
  events: _AddedEvent[];
  exhibitionId?: number;
  exhibitorId?: number;
  onDeleted?: (eventId: number) => void;
  onEdit?: (event: _AddedEvent) => void;
}

const AddedEvents = ({ events, exhibitionId, onDeleted, onEdit }: AddedEventsProps) => {
  const [editHovered, setEditHovered] = useState<number | null>(null);
  const { token } = useAuth();

 //TO DO 
function getColorForEvent(eventId: string): string {
  const colors = ["#6f87f6", "#89f4c9", "#fc8a06"];
  const hash = eventId.split("").reduce((acc, char) => acc + char.charCodeAt(0), 0);
  return colors[hash % colors.length];
}
  const haondleAddToOfficialCatalog = () => {
    console.log("Dodawanie wydarzenia do oficjalnego katalogu");
  }

  const handleEditEven = (event: _AddedEvent) => {
    try {
      console.log('[AddedEvents] Edit clicked, event =', event);
    } catch {}
    if (onEdit) onEdit(event);
  }
  const handleDeleteEven = useCallback(async (eventId?: number) => {
    if (!eventId || !token || !exhibitionId) return;
    if (!window.confirm('Usunąć to wydarzenie?')) return;
    try {
      await deleteTradeEvent(exhibitionId, eventId, token);
      if (onDeleted) onDeleted(eventId);
    } catch (e: any) {
      console.error('❌ Błąd usuwania wydarzenia', e);
      alert(e.message || 'Błąd podczas usuwania');
    }
  }, [token, exhibitionId, onDeleted]);
 //END



  


  return (
    <>
      {events.map((event, index) => {
        const circleColor = getColorForEvent(event.id ? String(event.id) : '');

        const eventDateObj = new Date(event.eventDate);

        return (
          <Box key={index} className={styles.container}>
            <Box className={styles.inRow}>
                {/* Sekcja Data */}
                <Box className={styles.date}>
                    <Box className={styles.iconWith}>
                        <Box
                        className={styles.coloredCircle}
                        style={{
                            '--circle-color': circleColor,
                            '--circle-text-color': textColorPicker(circleColor),
                        } as React.CSSProperties}
                        >
                        {eventDateObj.getDate()}<br />
                        {eventDateObj.toLocaleString('pl-PL', { month: 'short' })}
                        </Box>
                    </Box>
                    <Box className={styles.startAndEndDate}> {event.startTime} - {event.endTime}</Box>
                </Box>

                {/* Sekcja Info */}
                <Box className={styles.eventInfo}>
                    <Box className={styles.inRow}>
                        <Box>
                            <EventTypeBadge eventType={event.eventType} />
                            <Box className={styles.eventTitle}>{event.eventTitle}</Box>
                        </Box>
                        {('isEdited' in event)
                        ? <Box>
                            <span
                                onMouseEnter={() => setEditHovered(index)}
                                onMouseLeave={() => setEditHovered(null)}
                                onClick={() => handleEditEven(event)}
                                style={{ cursor: 'pointer', display: 'inline-flex' }}
                            >
                                {editHovered === index
                                ? <EditBlueIcon className={styles.editIcon} />
                                : <EditIcon className={styles.editIcon} />}
                            </span>
                          </Box>
                        :null}
                    </Box>
                    <Box className={styles.eventDescription}>{event.description}</Box>
                </Box>
            </Box>
            {/* Sekcja Organizator + Akcje */}
            <Box className={styles.lastRow}>
              <Box className={styles.organizer}>
                <CustomTypography className={styles.organizerLabel}>Organizator:</CustomTypography>
                <Box className={styles.organizerIcon}>
                  {event.organizerLogoUrl ? (
                    <img src={event.organizerLogoUrl} alt="logo" />
                  ) : (
                    <img src={LogoPtakExpo} alt="logo" />
                  )}
                </Box>
              </Box>

              <Box className={styles.actionButton}>
                {!('addedToOfficialCatalog' in event) ? (
                  <Box className={styles.inLine} onClick={() => handleDeleteEven(event.id)}>
                    <Wastebasket className={styles.actionLabelIcon} />
                    <Box className={styles.actionLabel}>Delete</Box>
                  </Box>
                ) : event.addedToOfficialCatalog ? (
                  <Box className={styles.inLine}>
                    <StarOutlineIcon className={styles.addedToOfficialCataloglIcon} />
                    <CustomTypography className={styles.addedToOfficialCatalog}>
                      Wydarzenie dodane do oficjalnego katalogu
                    </CustomTypography>
                  </Box>
                ) : (
                  <Box
                    className={styles.inLine}
                    onClick={haondleAddToOfficialCatalog}
                  >
                    <StarOutlineIcon sx={{ color: '#2E2E38' }} className={styles.notAddedToOfficialCatalogIcon} />
                    <CustomTypography className={styles.notAddedToOfficialCatalog}>
                      Dodaj wydarzenie do oficjalnego katalogu
                    </CustomTypography>
                  </Box>
                )}
              </Box>
            </Box>
          </Box>
        );
      })}
    </>
  );
};

export default AddedEvents;